// utils/date.ts
export const getLastMonths = (count = 10): string[] => {
  const months: string[] = [];
  const today = new Date();

  for (let i = 0; i < count; i++) {
    const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const monthName = date.toLocaleString('default', { month: 'long' });
    months.push(`${monthName} ${date.getFullYear()}`);
  }

  return months;
};
